import { render, staticRenderFns } from "./CardNewAnswer.vue?vue&type=template&id=ecffd16c"
import script from "./CardNewAnswer.vue?vue&type=script&lang=js"
export * from "./CardNewAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports